import { ChangeDetectorRef, Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AbstractStepDTO, SelectItem } from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-select-entry-point',
    templateUrl: './select-entry-point.component.html',
    styleUrls: ['./select-entry-point.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectEntryPointComponent),
            multi: true
        }],
    standalone: false
})
export class SelectEntryPointComponent implements OnInit, ControlValueAccessor {
  @Input() fieldId: string = 'fieldId'
  @Input() placeholder: string = 'components.select-entryPoint.placeholder';
  @Input() disabled: boolean = false;
  @Input() dropdownClass: string = '';

  availableEntryPoints: SelectItem[] = [];
  value: string = null;

  private onChange = (value: any) => {};
  private onTouched = () => {};

  constructor(
    private translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) { }


  ngOnInit(): void {
    this.initializeOptions();
  }

  private initializeOptions(): void {
    this.availableEntryPoints = [
      {
        label: this.translate.instant(`components.select-entryPoint.entryPoint.${AbstractStepDTO.TypeEnum.LANDINGPAGEEVENT}`),
        value: AbstractStepDTO.TypeEnum.LANDINGPAGEEVENT
      },
      {
        label: this.translate.instant(`components.select-entryPoint.entryPoint.${AbstractStepDTO.TypeEnum.CHANGEDATAEVENT}`),
        value: AbstractStepDTO.TypeEnum.CHANGEDATAEVENT
      },
      {
        label: this.translate.instant(`components.select-entryPoint.entryPoint.${AbstractStepDTO.TypeEnum.EMAILEVENT}`),
        value: AbstractStepDTO.TypeEnum.EMAILEVENT
      }
    ];
  }

  writeValue(value: any): void {
    this.value = value;
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }
  
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(event: string | { value?: string }): void {
    const value = typeof event === 'string' ? event : event?.value ?? null;
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }

}
